import React, { useRef } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import './Roadmap.css';
import arrow from '../images/redcoris-arrow.svg';

const Roadmap = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"]
    });

    const scaleY = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    });

    const milestones = [
        {
            quarter: "February 2026",
            title: "Beta testing",
            description: "(Echoes of Sin: Confusion) Start of closed beta testing of the game and fixing bugs.",
            side: "left"
        },
        {
            quarter: "June 9, 2026",
            title: "Game release",
            description: "(Echoes of Sin: Confusion) Game release on Steam.",
            side: "right"
        },
        {
            quarter: "July 2026",
            title: "Final game updates",
            description: "(Echoes of Sin: Confusion) Final game updates and community events.",
            side: "left"
        },
        {
            quarter: "August 2026",
            title: "A new beginning",
            description: "Preparation of a new game with a different feel and a new direction.",
            side: "right"
        },
    ];

    return (
        <section className="roadmap-section" ref={ref}>
            <div className="section-header">
                <img src={arrow} alt="arrow" className="section-arrow" />
                <h2><span className="brand-red">RED</span>Coris — <span className="section-title-white">Roadmap 2026</span></h2>
            </div>

            <div className="roadmap-container">
                {/* Central Line */}
                <div className="roadmap-line-container">
                    <motion.div
                        className="roadmap-line-progress"
                        style={{ scaleY }}
                    />
                </div>

                {milestones.map((item, index) => (
                    <MilestoneCard key={index} item={item} index={index} />
                ))}
            </div>
        </section>
    );
};

const MilestoneCard = ({ item, index }) => {
    const isLeft = item.side === "left";

    return (
        <motion.div
            className={`milestone-wrapper ${isLeft ? 'left' : 'right'}`}
            initial={{ opacity: 0, x: isLeft ? -50 : 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
        >
            <div className="milestone-content">
                <div className="milestone-quarter">{item.quarter}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <div className="milestone-marker"></div>
            </div>
        </motion.div>
    );
};

export default Roadmap;
